import { SectionBlockType } from "@/apps/page/page.interfaces";
import { Component } from "vue";
import * as Cta from "./cta/cta";
import * as Features from "./features/features";
import * as Hero from "./hero/hero";
import * as Logos from "./logos/logos";
import * as Navigation from "./navigation/navigation";
import * as Stats from "./stats/stats";
import * as Team from "./team/team";
import * as LongForm from "./long-form/long-form";
import * as Banner from "./banner/banner";
import * as Tables from "./tables/tables";
import * as Bento from "./bento/bento";
import * as Contact from "./contact/contact";

const blocks: Record<SectionBlockType, Record<string, Component>> = {
    banner: {
        ...Banner,
    },
    bentoGrid: {
        ...Bento,
    },
    contact: {
        ...Contact,
    },
    cta: {
        ...Cta,
    },
    features: {
        ...Features,
    },
    footer: {},
    header: {},
    hero: {
        ...Hero,
    },
    logos: {
        ...Logos,
    },
    nav: {
        ...Navigation,
    },
    newsletter: {},
    stats: {
        ...Stats,
    },
    tables: {
        ...Tables,
    },
    tabs: {},
    team: {
        ...Team,
    },
    longform: {
        ...LongForm,
    },
};

export default blocks;
